import css from './MainLogo.module.css';

export const MainLogo = ({ collapsed }) => {
  return (
    <div className={css.logo} alt="Main site logo"/>
  )
}